import React from 'react';
import styled from 'styled-components';
import { SectionTitle, BodyText } from '../Global';
import CallToAction from '../CallToAction';

const StartSection = styled.div`
  width: 100%;
  max-width: 427px;
  margin: auto;
  text-align: center;
`;

const SimplifyTeamWork = () => (
  <StartSection>
    <SectionTitle mb="17px">Simplify team work</SectionTitle>
    <BodyText mb="40px">Install Workast to your Slack workspace and start organizing your team work today.</BodyText>
    <CallToAction text="GetStarted" />
  </StartSection>
);

export default SimplifyTeamWork;
